import { createAction } from '@reduxjs/toolkit';
export const DELETE_VOICEMAIL = 'DELETE_VOICEMAIL';
export const deleteVoicemailAction = createAction(DELETE_VOICEMAIL);
